import { Component, Vue } from 'vue-property-decorator';
import { KlaviyoSyncRun } from '@/models/KlaviyoSyncRun';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';

@Component<KlaviyoSync>({})
export default class KlaviyoSync extends Vue {
  protected syncRuns: KlaviyoSyncRun[] = [];
  protected isLoading: boolean = true;
  protected selectedDomain: string = '';

  protected domainOptions: string[] = ['', 'NL', 'DE'];
  protected pagination: object = { rowsPerPage: -1 };
  protected tableHeaders: object[] = [
    { text: 'Domain', value: 'domain', sortable: false },
    { text: 'Started', value: 'started_at', sortable: false },
    { text: 'Duration', value: 'duration', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Fetched', value: 'rows_fetched', sortable: false },
    { text: 'Updated', value: 'rows_updated', sortable: false },
    { text: 'Created', value: 'rows_created', sortable: false },
    { text: 'Inbound only', value: 'rows_inbound_only', sortable: false },
    { text: 'Failed', value: 'rows_failed', sortable: false },
  ];

  protected async mounted() {
    await this.fetchSyncRuns();
  }

  protected async fetchSyncRuns() {
    this.isLoading = true;

    const model = new KlaviyoSyncRun()
      .limit(20)
      .sort('started_at', 'DESC');

    if (this.selectedDomain) {
      model.filter('domain', this.selectedDomain);
    }

    await model
      .all()
      .then((runs: KlaviyoSyncRun[]) => {
        this.syncRuns = runs;
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  protected getStatusColor(status: string): string {
    switch (status) {
      case 'success': return 'green';
      case 'partial': return 'orange';
      case 'failed': return 'red';
      case 'running': return 'blue';
      default: return 'grey';
    }
  }

  protected formatDate(dateString: string | undefined): string {
    if (!dateString) return '-';

    const date = new Date(dateString);
    return date.toLocaleDateString('nl-NL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  protected getDuration(run: KlaviyoSyncRun): string {
    if (!run.started_at || !run.finished_at) return '-';

    const start = new Date(run.started_at).getTime();
    const end = new Date(run.finished_at).getTime();
    const diffMs = end - start;

    if (diffMs < 1000) return `${diffMs}ms`;

    const seconds = Math.floor(diffMs / 1000);
    if (seconds < 60) return `${seconds}s`;

    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m ${remainingSeconds}s`;
  }
}
